import '../styles/global.scss';
import '@wix/design-system/styles.global.css';

import { WixDesignSystemProvider } from '@wix/design-system';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { httpClient } from '../common/httpClient';
import { FedopsLoggerProvider } from '../common/providers/fedopsLogger';
import { HeaderFooterProvider } from '../common/providers/headerFooter';
import { HttpClientProvider } from '../common/providers/httpClient';
import { store } from '../common/store';
import { ErrorBoundary, ErrorScreen } from '../error';
import { fedopsLogger, renderModel } from '../util/renderModel';
import App from './App';

const { locale, messages, headerAndFooterData } = renderModel.get();
const i18n = initI18n({ locale, messages });

ReactDOM.render(
  <Suspense fallback="...loading">
    <I18nextProvider i18n={i18n}>
      <FedopsLoggerProvider logger={fedopsLogger}>
        <HttpClientProvider httpClient={httpClient}>
          <Provider store={store}>
            <WixDesignSystemProvider features={{ newColorsBranding: true }}>
              <ErrorBoundary fallback={<ErrorScreen />}>
                <HeaderFooterProvider headerAndFooterData={headerAndFooterData}>
                  <App />
                </HeaderFooterProvider>
              </ErrorBoundary>
            </WixDesignSystemProvider>
          </Provider>
        </HttpClientProvider>
      </FedopsLoggerProvider>
    </I18nextProvider>
  </Suspense>,
  document.getElementById('root'),
);
